export default __webpack_public_path__ + "static/media/date_time.2bc42e65.svg";